export const STORAGE_SESSION_ACTIVE = "sessionActive"
export const STORAGE_DARK_MODE = "darkMode"
export const STORAGE_SELECTED_TAB = "selectedTab"
export const STORAGE_ENCRYPTED_DATA = "EncryptedData"
export const STORAGE_IV = "Iv"
export const STORAGE_ARTICLES_BY_MARTIN = "articlesByMartin"
export const STORAGE_SUF = "suffix"

export const tabs = {
  UPLOAD: "upload",
  COPY: "copy",
  INVOICE: "invoice",
  IMAGE_UPLOAD: "imageUpload",
  SHARE_POST: "sharePost",
  CLEAR_CACHE: "clearCache",
}

export const backupTabs = {
  WORD_FILES: "wordFiles",
  KN_IMAGES: "knImages",
  FTN_IMAGES: "ftnImages",
}

export const CRYPTO_NEWS_URL = "https://www.kryptonovinky.sk/"
export const FT_NEWS_URL = "https://www.ftnews.sk/"

const { REACT_APP_URL, REACT_APP_PORT, REACT_APP_IS_LOCAL_TESTING, REACT_APP_BASE_URL } =
  process.env
const isLocalTesting = REACT_APP_IS_LOCAL_TESTING === "true"

export const BASE_URL = isLocalTesting
  ? `${REACT_APP_URL}:${REACT_APP_PORT}`
  : REACT_APP_BASE_URL || "https://api.bytcoin.sk"

export const WEB_PORTALS = {
  slovakCryptoNews: "knSk",
  czechCryptoNews: "knCz",
  slovakFtNews: "ftnSk",
  czechFtNews: "ftnCz",
}

export const DUMMY_FORM_VALUE = "••••••"

export const processes = {
  UPLOADING: "uploading",
  COPYING: "copying",
}

export const TRANSLATOR_URL =
  "https://chatgpt.com/g/g-67874c3624508191b12bf04b57596449-prekladac-sk-cz-k-html-tagmi"

export const APP_CREATOR = "Marián Lukáč"
export const APP_CREATOR_URL = "https://marianlukac.sk"

export const MIN_PUBLISH_DELAY_MINUTES = 25

export const KN_PUBLISH_HOURS = [8, 9, 17, 13, 15, 11, 19, 16, 18, 14, 12, 10, 20]
export const FTN_PUBLISH_HOURS = [8, 18, 14, 16, 12, 10, 17, 15, 19, 20, 13, 11, 9]

export const endpoints = {
  BACKUP: "backup-files",
  CLEAR_CACHE: "clear-cache",
  CONVERT: "convert-v2",
  // CONVERT: "convert",
  COPY: "copy-v2",
  // COPY: "copy",
  DEPLOY_IMAGES: "deploy-images",
  GET_KEY: "get-key",
  LOGIN: "login",
  SYSTEM_LOGIN: "auth/login",
  SYSTEM_LOGOUT: "auth/logout",
  UPLOADED_FILES: "uploaded-files",
}
